const getters = {
    test: state => state.vuexTest.test,
}
export default getters